import { createSelector, createStructuredSelector } from 'reselect';
import { RootState } from 'types/state';
import { SectionConfig, SubsectionConfig } from './reducer';

export const getSectionState = (state: RootState) => state.section;
export const getSectionKey = (state: RootState) => state.section.section.key;
export const getSubsectionKey = (state: RootState) => getSectionState(state).subsection.key;

interface GetSectionKeys {
  sectionKey: SectionConfig['key']
  subsectionKey: SubsectionConfig['key']
}
/**
 * getSectionKeys returns sectionKey and subsectionKey of state.section.
 */
export const getSectionKeys = createStructuredSelector<RootState, GetSectionKeys>({
  sectionKey: getSectionKey,
  subsectionKey: getSubsectionKey,
});

export const getIsSectionInReview = createSelector(
  getSubsectionKey,
  (subsectionKey) => subsectionKey !== null && subsectionKey.includes('_REVIEW')
) || false;
